import React, { useState, useEffect, useRef } from 'react'
import {
  Box, Card, CardContent, CardHeader, Grid, TextField, Button,
  MenuItem, Select, FormControl, InputLabel, Typography,
  RadioGroup, FormControlLabel, Radio, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Tooltip, Divider, Stack, Chip, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions, Alert, LinearProgress
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import SearchIcon from '@mui/icons-material/Search'
import SaveIcon from '@mui/icons-material/Save'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import ArticleIcon from '@mui/icons-material/Article'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import normaService from '../services/normaService'
import documentoService from '../services/documentoService'
import authService from '../services/authService'
import PageHeader from '../components/common/PageHeader'
import ConfirmDialog from '../components/common/ConfirmDialog'

export default function NuevaPublicacion() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const fileInputRef = useRef(null)

  const casoUso = normaService.getNormaLegalToUpdate().id ? 'update' : 'create'
  const idNormaLegalEdit = normaService.getNormaLegalToUpdate().id || ''

  // ── campos principales ────────────────────────────────────────────
  const [tipoNormasPorOficina, setTipoNormasPorOficina] = useState([])
  const [selectedTipoNorma, setSelectedTipoNorma] = useState('')
  const [numNorma, setNumNorma] = useState(normaService.getNormaLegalToUpdate().numero || '')
  const [numNormaDisabled, setNumNormaDisabled] = useState(false)
  const [fechaFirma, setFechaFirma] = useState('')
  const [caracter, setCaracter] = useState('Individual')
  const [voces, setVoces] = useState([])
  const [selectedVoz, setSelectedVoz] = useState('')
  const [resena, setResena] = useState('')
  const [pdfFile, setPdfFile] = useState(null)
  const [pdfDetails, setPdfDetails] = useState('')
  const [showSelectPdf, setShowSelectPdf] = useState(true)
  const [saving, setSaving] = useState(false)

  // ── normas afectadas ──────────────────────────────────────────────
  const [tiposAfectacion, setTiposAfectacion] = useState([])
  const [normasAfectadas, setNormasAfectadas] = useState([])
  const [afectadaDialogOpen, setAfectadaDialogOpen] = useState(false)
  const [afectadaCasoUso, setAfectadaCasoUso] = useState('new')
  const [afectadaIdx, setAfectadaIdx] = useState(-1)

  // campos para la norma afectada
  const [buscarNLAfectadaOpen, setBuscarNLAfectadaOpen] = useState(false)
  const [buscarTipo, setBuscarTipo] = useState('')
  const [buscarNumero, setBuscarNumero] = useState('')
  const [buscarResultados, setBuscarResultados] = useState([])
  const [buscarLoading, setBuscarLoading] = useState(false)
  const [nlAfectadaId, setNlAfectadaId] = useState('')
  const [nlAfectadaTipo, setNlAfectadaTipo] = useState('')
  const [nlAfectadaNumero, setNlAfectadaNumero] = useState('')
  const [nlAfectadaUo, setNlAfectadaUo] = useState('')
  const [nlAfectadaOficina, setNlAfectadaOficina] = useState('')
  const [nlAfectadaFecha, setNlAfectadaFecha] = useState('')
  const [nlAfectadaCaracter, setNlAfectadaCaracter] = useState('')
  const [nlAfectadaVoz, setNlAfectadaVoz] = useState('')
  const [nlAfectadaIdTipoNl, setNlAfectadaIdTipoNl] = useState('')
  const [tipoAfectacionSel, setTipoAfectacionSel] = useState('')
  const [detalleAfectacion, setDetalleAfectacion] = useState('')

  // ── destinatarios ─────────────────────────────────────────────────
  const [destinosList, setDestinosList] = useState([])
  const [selectedDestino, setSelectedDestino] = useState('')
  const [destinosAgregados, setDestinosAgregados] = useState([])

  // ── confirm dialogs ───────────────────────────────────────────────
  const [confirmPublicacion, setConfirmPublicacion] = useState(false)
  const [confirmDeleteAfectada, setConfirmDeleteAfectada] = useState(null)

  const parseDisplayDate = (raw) => {
    if (!raw) return ''
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return raw

    const normalized = String(raw).replace(/-/g, '/').split(' ')[0]
    const parts = normalized.split('/')
    if (parts.length !== 3) return raw

    // yyyy/mm/dd -> dd/mm/yyyy
    if (parts[0].length === 4) {
      return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`
    }
    return raw
  }

  const toDate = (displayDate) => {
    if (!displayDate || !/^\d{2}\/\d{2}\/\d{4}$/.test(displayDate)) return null
    const [dd, mm, yyyy] = displayDate.split('/').map(Number)
    const dt = new Date(yyyy, mm - 1, dd)
    return Number.isNaN(dt.getTime()) ? null : dt
  }

  // ── init ──────────────────────────────────────────────────────────
  useEffect(() => {
    const area = authService.getUserDataArea()[0]

    normaService.getOficinas(null, area).then(res => {
      const oficinas = res.data?.data || []
      if (oficinas.length > 0) {
        normaService.getTiposNormasPorOficina(oficinas[0].id).then(r2 => {
          setTipoNormasPorOficina(r2.data?.data || [])
          if (casoUso === 'update') {
            const idTipoNl = normaService.getNormaLegalToUpdate().id_tipo_nl
            setSelectedTipoNorma(idTipoNl)
            const tipo = (r2.data?.data || []).find(t => t.id_tipo_nl === idTipoNl)
            if (tipo && !tipo.numero_requerido) { setNumNormaDisabled(true); setNumNorma('') }
          }
        }).catch(() => enqueueSnackbar('No se pudieron cargar los tipos de norma de su oficina', { variant: 'error' }))
      }
    }).catch(() => enqueueSnackbar('No se pudieron cargar las oficinas del usuario', { variant: 'error' }))

    normaService.getAfectaciones().then(res => setTiposAfectacion(res.data?.data || [])).catch(() => enqueueSnackbar('No se pudieron cargar los tipos de afectación', { variant: 'error' }))
    normaService.getOficinaNotif().then(res => setDestinosList(res.data?.data || [])).catch(() => enqueueSnackbar('No se pudieron cargar las oficinas de notificación', { variant: 'error' }))

    if (casoUso === 'update') loadNormaLegal()
  }, [])

  useEffect(() => {
    const tipo = caracter === 'Individual' ? 'i' : 'g'
    normaService.getVoces(null, null, tipo).then(res => {
      setVoces(res.data?.data || [])
    }).catch(() => enqueueSnackbar('No se pudieron cargar las voces', { variant: 'error' }))
  }, [caracter])

  const loadNormaLegal = () => {
    documentoService.getNormaById(idNormaLegalEdit).then(res => {
      const nl = res.data?.data?.[0]?.norma_legal
      const afectadas = res.data?.data?.[0]?.normas_legales_afectadas || []
      const notifs = res.data?.data?.[0]?.normas_legales_oficinas_notif || []

      if (!nl) return
      setFechaFirma(parseDisplayDate(nl.fecha_firma || ''))
      const car = nl.caracter || 'individual'
      setCaracter(car.charAt(0).toUpperCase() + car.slice(1))
      setSelectedVoz(nl.id_voz_nl || '')
      setResena(nl.resena || '')
      setPdfDetails(nl.pdf_name ? `${nl.pdf_name} (${nl.pdf_length})` : '')
      setShowSelectPdf(!nl.pdf_name)

      setNormasAfectadas(afectadas.map((a, i) => ({
        orden: i + 1,
        id_norma_legal: a.id_norma_legal_afectada,
        id_tipo_nl: a.id_tipo_nl,
        descripcion_tipo_nl: a.descripcion_tipo_nl,
        numero: a.numero,
        fecha_firma: a.fecha_firma,
        id_afectacion_nl: a.id_afectacion_nl,
        descripcion_afectacion_nl: a.descripcion_afectacion,
        detalle_afectacion: a.detalle_afectacion,
      })))

      setDestinosAgregados(notifs.map((n, i) => ({
        orden: i + 1,
        id: n.id_oficina_notif,
        descripcion: n.descripcion_oficina_notif,
        email: n.email_oficina_notif,
      })))
    }).catch(() => enqueueSnackbar('No se pudo cargar la norma legal seleccionada', { variant: 'error' }))
  }

  const onChangeTipoNorma = (idTipoNl) => {
    setSelectedTipoNorma(idTipoNl)
    const tipo = tipoNormasPorOficina.find(t => t.id_tipo_nl === idTipoNl)
    if (tipo) {
      if (!tipo.numero_requerido) { setNumNormaDisabled(true); setNumNorma('') }
      else setNumNormaDisabled(false)
    }
  }

  const handleFileSelect = (e) => {
    const f = e.target.files?.[0]
    if (f) {
      setPdfFile(f)
      setPdfDetails(`${f.name} (${(f.size / 1024).toFixed(1)} KB)`)
      setShowSelectPdf(false)
    }
  }

  const validateForm = () => {
    if (!selectedTipoNorma) { enqueueSnackbar('Seleccione un Tipo de Norma Legal', { variant: 'warning' }); return false }
    if (!numNormaDisabled && !numNorma) { enqueueSnackbar('Ingrese el Número de la Norma Legal', { variant: 'warning' }); return false }
    if (!fechaFirma || fechaFirma.length < 10) { enqueueSnackbar('Ingrese una fecha de firma válida (dd/mm/yyyy)', { variant: 'warning' }); return false }
    if (!selectedVoz) { enqueueSnackbar('Seleccione una Voz', { variant: 'warning' }); return false }
    if (!resena.trim()) { enqueueSnackbar('Ingrese el Tema/Reseña', { variant: 'warning' }); return false }
    if (casoUso === 'create' && !pdfFile) { enqueueSnackbar('Seleccione un archivo PDF', { variant: 'warning' }); return false }
    return true
  }

  const handlePublicar = () => {
    if (!validateForm()) return
    setConfirmPublicacion(true)
  }

  const handleConfirmPublicar = async () => {
    setConfirmPublicacion(false)
    setSaving(true)

    try {
      const savePayload = buildNormaLegalPayload()
      const saveResponse = await documentoService.saveNormaLegal(savePayload)
      const savedIdNormaLegal = saveResponse?.data?.id_norma_legal || idNormaLegalEdit

      if (savedIdNormaLegal && destinosAgregados.length > 0) {
        const listToEmail = destinosAgregados
          .filter((destino) => Boolean(destino.email))
          .map((destino) => ({
            id_norma_legal: savedIdNormaLegal,
            id_oficina_notif: destino.id,
          }))

        if (listToEmail.length > 0) {
          try {
            await documentoService.sendEmail(listToEmail)
          } catch {
            enqueueSnackbar('La norma se guardó, pero falló el envío de notificaciones por email', { variant: 'warning' })
          }
        }
      }

      if (savedIdNormaLegal && savePayload.cambio_pdf) {
        try {
          await documentoService.triggerOCRProcessing(savedIdNormaLegal)
        } catch {
          enqueueSnackbar('La norma se guardó, pero no se pudo iniciar el procesamiento OCR', { variant: 'warning' })
        }
      }

      normaService.setNormaLegalToUpdate('', '', '')
      enqueueSnackbar(`Norma Legal ${casoUso === 'create' ? 'publicada' : 'actualizada'} correctamente`, { variant: 'success' })
      navigate('/normas')
    } catch (err) {
      const backendMessage = err?.response?.data?.message_description || err?.response?.data?.error_description || err?.response?.data?.message
      enqueueSnackbar(backendMessage || 'Error al guardar la Norma Legal', { variant: 'error' })
    } finally {
      setSaving(false)
    }
  }

  const buildNormaLegalPayload = () => {
    const isUpdate = casoUso === 'update' && Boolean(idNormaLegalEdit)
    const dateParts = fechaFirma.split('/')
    const fechaISO = dateParts.length === 3 ? `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}` : fechaFirma

    const nlAfectadasPayload = normasAfectadas.map(a => ({
      id_norma_legal: a.id_norma_legal,
      id_afectacion_nl: a.id_afectacion_nl,
      detalle_afectacion: a.detalle_afectacion || '',
    }))

    const oficinasNotifPayload = destinosAgregados.map(d => ({ id: d.id }))
    const cambioPdf = casoUso === 'create' ? true : Boolean(pdfFile)

    return {
      id: isUpdate ? idNormaLegalEdit : '',
      id_tipo_nl: selectedTipoNorma,
      numero: numNormaDisabled ? '' : numNorma,
      fecha_firma: fechaISO,
      caracter: caracter.toLowerCase(),
      id_voz_nl: selectedVoz,
      resena,
      nl_afectadas: nlAfectadasPayload,
      oficinas_notif: oficinasNotifPayload,
      cambio_pdf: cambioPdf,
      file: pdfFile,
    }
  }

  // ── Buscar norma legal afectada ───────────────────────────────────
  const handleBuscarNLAfectada = async () => {
    setBuscarLoading(true)
    try {
      const res = await documentoService.getNormasLegales({
        idTipo: buscarTipo, numero: buscarNumero,
        resena: '', fechaDesde: '', fechaHasta: '', caracter: '', idVoz: '',
        rows: 10, first: 0,
      })
      setBuscarResultados(res.data?.data || [])
    } catch {
      enqueueSnackbar('Error al buscar normas', { variant: 'error' })
    } finally {
      setBuscarLoading(false)
    }
  }

  const seleccionarNLAfectada = (nl) => {
    setNlAfectadaId(nl.id)
    setNlAfectadaIdTipoNl(nl.id_tipo_nl)
    setNlAfectadaTipo(nl.descripcion_tipo_nl)
    setNlAfectadaNumero(nl.numero)
    setNlAfectadaUo(nl.descripcion_uo)
    setNlAfectadaOficina(nl.descripcion_oficina)
    setNlAfectadaFecha(nl.fecha_firma)
    setNlAfectadaCaracter(nl.caracter)
    setNlAfectadaVoz(nl.descripcion_voz_nl)
    setBuscarNLAfectadaOpen(false)
  }

  const agregarNormaAfectada = () => {
    if (!nlAfectadaId || !tipoAfectacionSel) {
      enqueueSnackbar('Complete los datos de la Norma Legal afectada', { variant: 'warning' })
      return
    }

    const fechaNormaPrincipal = toDate(fechaFirma)
    const fechaNormaAfectada = toDate(nlAfectadaFecha)
    if (fechaNormaPrincipal && fechaNormaAfectada && fechaNormaPrincipal < fechaNormaAfectada) {
      enqueueSnackbar('La fecha de firma de la Norma Legal debe ser igual o posterior a la de sus Normas Legales afectadas', { variant: 'warning' })
      return
    }

    const repetida = normasAfectadas.some((a, idx) => (
      idx !== afectadaIdx &&
      a.id_norma_legal === nlAfectadaId &&
      a.id_afectacion_nl === tipoAfectacionSel
    ))
    if (repetida) {
      enqueueSnackbar('La Norma Legal y tipo de afectación ya fue agregada', { variant: 'warning' })
      return
    }

    const tipoAf = tiposAfectacion.find(t => t.id === tipoAfectacionSel)
    const entrada = {
      orden: afectadaCasoUso === 'new' ? normasAfectadas.length + 1 : afectadaIdx + 1,
      id_norma_legal: nlAfectadaId,
      id_tipo_nl: nlAfectadaIdTipoNl,
      descripcion_tipo_nl: nlAfectadaTipo,
      numero: nlAfectadaNumero,
      fecha_firma: nlAfectadaFecha,
      id_afectacion_nl: tipoAfectacionSel,
      descripcion_afectacion_nl: tipoAf?.descripcion || '',
      detalle_afectacion: detalleAfectacion,
    }

    if (afectadaCasoUso === 'new') {
      setNormasAfectadas(prev => [...prev, entrada])
    } else {
      setNormasAfectadas(prev => prev.map((a, i) => i === afectadaIdx ? entrada : a))
    }
    clearNlAfectadaForm()
    setAfectadaDialogOpen(false)
  }

  const clearNlAfectadaForm = () => {
    setNlAfectadaId(''); setNlAfectadaIdTipoNl(''); setNlAfectadaTipo('')
    setNlAfectadaNumero(''); setNlAfectadaUo(''); setNlAfectadaOficina('')
    setNlAfectadaFecha(''); setNlAfectadaCaracter(''); setNlAfectadaVoz('')
    setTipoAfectacionSel(''); setDetalleAfectacion('')
    setBuscarTipo(''); setBuscarNumero(''); setBuscarResultados([])
    setAfectadaCasoUso('new'); setAfectadaIdx(-1)
  }

  const editAfectada = (idx) => {
    const a = normasAfectadas[idx]
    setAfectadaCasoUso('edit')
    setAfectadaIdx(idx)
    setNlAfectadaId(a.id_norma_legal)
    setNlAfectadaIdTipoNl(a.id_tipo_nl)
    setNlAfectadaTipo(a.descripcion_tipo_nl)
    setNlAfectadaNumero(a.numero)
    setNlAfectadaFecha(a.fecha_firma)
    setTipoAfectacionSel(a.id_afectacion_nl)
    setDetalleAfectacion(a.detalle_afectacion || '')
    setAfectadaDialogOpen(true)
  }

  const agregarDestino = () => {
    if (!selectedDestino) return
    if (destinosAgregados.find(d => d.id === selectedDestino)) {
      enqueueSnackbar('La Oficina a notificar ya fue agregada', { variant: 'warning' }); return
    }
    const dest = destinosList.find(d => d.id === selectedDestino)
    if (dest) setDestinosAgregados(prev => [...prev, { ...dest, orden: prev.length + 1 }])
    setSelectedDestino('')
  }

  return (
    <Box>
      <PageHeader
        title={casoUso === 'create' ? 'Nueva Norma Legal' : 'Editando Norma Legal'}
        subtitle="Complete todos los campos obligatorios (*)"
        icon={ArticleIcon}
      />

      {saving && <LinearProgress sx={{ mb: 2 }} />}

      {/* ── Datos principales ── */}
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Datos de la Norma Legal"
          titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600, color: 'primary.main' }}
          sx={{ pb: 0 }}
        />
        <CardContent>
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Tipo de Norma Legal *</InputLabel>
                <Select value={selectedTipoNorma} label="Tipo de Norma Legal *" onChange={e => onChangeTipoNorma(e.target.value)}>
                  {tipoNormasPorOficina.map(t => (
                    <MenuItem key={t.id_tipo_nl} value={t.id_tipo_nl}>{t.descripcion_tipo_nl}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth size="small"
                label={numNormaDisabled ? 'Número (no requerido)' : 'Número *'}
                value={numNorma}
                onChange={e => setNumNorma(e.target.value)}
                disabled={numNormaDisabled}
                inputProps={{ maxLength: 15 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth size="small"
                label="Fecha de Firma * (dd/mm/yyyy)"
                value={fechaFirma}
                onChange={e => setFechaFirma(e.target.value)}
                placeholder="dd/mm/yyyy"
                inputProps={{ maxLength: 10 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>Carácter *</Typography>
              <RadioGroup row value={caracter} onChange={e => setCaracter(e.target.value)}>
                <FormControlLabel value="Individual" control={<Radio size="small" />} label="Individual" />
                <FormControlLabel value="General" control={<Radio size="small" />} label="General" />
              </RadioGroup>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Voz *</InputLabel>
                <Select value={selectedVoz} label="Voz *" onChange={e => setSelectedVoz(e.target.value)}>
                  {voces.map(v => <MenuItem key={v.id} value={v.id}>{v.descripcion}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth multiline rows={4}
                label="Tema / Reseña *"
                value={resena}
                onChange={e => setResena(e.target.value)}
                inputProps={{ maxLength: 1000 }}
              />
            </Grid>

            {/* PDF */}
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Documento PDF {casoUso === 'create' ? '*' : ''}</Typography>
              {pdfDetails && (
                <Chip label={pdfDetails} color="success" variant="outlined" sx={{ mb: 1 }} />
              )}
              {showSelectPdf && (
                <>
                  <input ref={fileInputRef} type="file" accept="application/pdf" style={{ display: 'none' }} onChange={handleFileSelect} />
                  <Button variant="outlined" startIcon={<UploadFileIcon />} onClick={() => fileInputRef.current?.click()}>
                    Seleccionar PDF
                  </Button>
                </>
              )}
              {!showSelectPdf && casoUso === 'update' && (
                <Button variant="text" size="small" onClick={() => setShowSelectPdf(true)}>
                  Cambiar PDF
                </Button>
              )}
              {showSelectPdf && casoUso === 'update' && (
                <>
                  <input ref={fileInputRef} type="file" accept="application/pdf" style={{ display: 'none' }} onChange={handleFileSelect} />
                  <Button variant="outlined" startIcon={<UploadFileIcon />} onClick={() => fileInputRef.current?.click()}>
                    Seleccionar nuevo PDF
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* ── Normas Afectadas ── */}
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Normas Legales a las que afecta"
          titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600, color: 'primary.main' }}
          action={
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => { clearNlAfectadaForm(); setAfectadaDialogOpen(true) }}>
              Agregar
            </Button>
          }
          sx={{ pb: 0 }}
        />
        <CardContent>
          {normasAfectadas.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
              No se han agregado normas legales afectadas
            </Typography>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Número</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Tipo Afectación</TableCell>
                    <TableCell>Detalle</TableCell>
                    <TableCell align="center">Acc.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {normasAfectadas.map((a, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{a.descripcion_tipo_nl}</TableCell>
                      <TableCell>{a.numero}</TableCell>
                      <TableCell>{a.fecha_firma}</TableCell>
                      <TableCell>{a.descripcion_afectacion_nl}</TableCell>
                      <TableCell>{a.detalle_afectacion}</TableCell>
                      <TableCell align="center">
                        <IconButton size="small" color="primary" onClick={() => editAfectada(idx)}><EditIcon fontSize="small" /></IconButton>
                        <IconButton size="small" color="error" onClick={() => setConfirmDeleteAfectada(idx)}><DeleteIcon fontSize="small" /></IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>

      {/* ── Destinatarios ── */}
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Oficinas a Notificar"
          titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600, color: 'primary.main' }}
          sx={{ pb: 0 }}
        />
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <FormControl size="small" sx={{ minWidth: 300 }}>
              <InputLabel>Seleccionar Oficina</InputLabel>
              <Select value={selectedDestino} label="Seleccionar Oficina" onChange={e => setSelectedDestino(e.target.value)}>
                {destinosList.map(d => <MenuItem key={d.id} value={d.id}>{d.descripcion}</MenuItem>)}
              </Select>
            </FormControl>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={agregarDestino}>Agregar</Button>
          </Stack>
          {destinosAgregados.length > 0 && (
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {destinosAgregados.map((d, i) => (
                <Chip key={i} label={`${d.descripcion} (${d.email || '—'})`} onDelete={() => setDestinosAgregados(prev => prev.filter((_, ii) => ii !== i))} />
              ))}
            </Stack>
          )}
        </CardContent>
      </Card>

      {/* ── Acciones ── */}
      <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate('/normas')}>
          Cancelar
        </Button>
        <Button variant="contained" startIcon={<SaveIcon />} onClick={handlePublicar} disabled={saving}>
          {casoUso === 'create' ? 'Publicar' : 'Actualizar'}
        </Button>
      </Stack>

      {/* ── Dialog: Agregar norma afectada ── */}
      <Dialog open={afectadaDialogOpen} onClose={() => { clearNlAfectadaForm(); setAfectadaDialogOpen(false) }} maxWidth="md" fullWidth>
        <DialogTitle>{afectadaCasoUso === 'new' ? 'Agregar Norma Legal Afectada' : 'Editar Norma Legal Afectada'}</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button variant="outlined" startIcon={<SearchIcon />} onClick={() => setBuscarNLAfectadaOpen(true)}>
                Buscar Norma Legal
              </Button>
            </Grid>
            {[
              ['Tipo de Norma Legal', nlAfectadaTipo],
              ['Número', nlAfectadaNumero],
              ['Unidad Organizativa', nlAfectadaUo],
              ['Oficina', nlAfectadaOficina],
              ['Fecha', nlAfectadaFecha],
              ['Carácter', nlAfectadaCaracter],
              ['Voz', nlAfectadaVoz],
            ].map(([label, value]) => (
              <Grid item xs={12} md={6} key={label}>
                <TextField fullWidth size="small" label={label} value={value} disabled />
              </Grid>
            ))}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo de Afectación *</InputLabel>
                <Select value={tipoAfectacionSel} label="Tipo de Afectación *" onChange={e => setTipoAfectacionSel(e.target.value)}>
                  {tiposAfectacion.map(t => <MenuItem key={t.id} value={t.id}>{t.descripcion}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" label="Detalle de Afectación" value={detalleAfectacion} onChange={e => setDetalleAfectacion(e.target.value)} multiline rows={2} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { clearNlAfectadaForm(); setAfectadaDialogOpen(false) }}>Cancelar</Button>
          <Button variant="contained" onClick={agregarNormaAfectada}>
            {afectadaCasoUso === 'new' ? 'Agregar' : 'Actualizar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog: Búsqueda de NL Afectada ── */}
      <Dialog open={buscarNLAfectadaOpen} onClose={() => setBuscarNLAfectadaOpen(false)} maxWidth="lg" fullWidth>
        <DialogTitle>Buscar Norma Legal</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={5}>
              <FormControl fullWidth size="small">
                <InputLabel>Tipo</InputLabel>
                <Select value={buscarTipo} label="Tipo" onChange={e => setBuscarTipo(e.target.value)}>
                  <MenuItem value="">TODAS</MenuItem>
                  {tipoNormasPorOficina.map(t => <MenuItem key={t.id_tipo_nl} value={t.id_tipo_nl}>{t.descripcion_tipo_nl}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Número" value={buscarNumero} onChange={e => setBuscarNumero(e.target.value)} />
            </Grid>
            <Grid item xs={12} md={3}>
              <Button fullWidth variant="contained" startIcon={buscarLoading ? <CircularProgress size={16} color="inherit" /> : <SearchIcon />} onClick={handleBuscarNLAfectada} disabled={buscarLoading}>
                Buscar
              </Button>
            </Grid>
          </Grid>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Tipo</TableCell>
                  <TableCell>Número</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Voz</TableCell>
                  <TableCell>Tema</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {buscarResultados.map((nl, i) => (
                  <TableRow key={i} hover>
                    <TableCell>{nl.descripcion_tipo_nl}</TableCell>
                    <TableCell>{nl.numero}</TableCell>
                    <TableCell>{nl.fecha_firma}</TableCell>
                    <TableCell>{nl.descripcion_voz_nl}</TableCell>
                    <TableCell>{nl.resena_short || nl.resena}</TableCell>
                    <TableCell>
                      <Button size="small" variant="outlined" onClick={() => seleccionarNLAfectada(nl)}>Seleccionar</Button>
                    </TableCell>
                  </TableRow>
                ))}
                {buscarResultados.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="body2" color="text.secondary">Realice una búsqueda</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBuscarNLAfectadaOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* Confirmar publicación */}
      <ConfirmDialog
        open={confirmPublicacion}
        title={casoUso === 'create' ? 'Publicar Norma Legal' : 'Actualizar Norma Legal'}
        message={`¿Confirma ${casoUso === 'create' ? 'la publicación' : 'la actualización'} de la norma legal?`}
        onConfirm={handleConfirmPublicar}
        onCancel={() => setConfirmPublicacion(false)}
      />

      {/* Confirmar eliminación de norma afectada */}
      <ConfirmDialog
        open={confirmDeleteAfectada !== null}
        title="Eliminar Norma Afectada"
        message="¿Confirma la eliminación de esta norma legal afectada?"
        onConfirm={() => { setNormasAfectadas(prev => prev.filter((_, i) => i !== confirmDeleteAfectada)); setConfirmDeleteAfectada(null) }}
        onCancel={() => setConfirmDeleteAfectada(null)}
      />
    </Box>
  )
}
